<template>
  <VRadioGroup
    :model-value="shift"
    :disabled="disabled"
    hide-details
    @update:model-value="(value) => emit('shift-update', value as ShiftTypeDTO)"
  >
    <VRadio
      v-for="item in availableShiftTypes"
      :key="`shift-radio-button-${item}`"
      :label="translateShiftTypeDTO(item, t)"
      :value="item"
      :data-testid="item"
      :ripple="false"
      base-color="secondary-text"
    />
  </VRadioGroup>
</template>

<script setup lang="ts">
import { translateShiftTypeDTO } from '@/util/translations'
import { ShiftTypeDTO } from '@/generated'
import { useI18n } from 'vue-i18n'

interface Emits {
  (e: 'shift-update', value: ShiftTypeDTO): void
}

interface Props {
  shift: ShiftTypeDTO | undefined
  disabled?: boolean
}

const { t } = useI18n()

const { shift } = defineProps<Props>()
const emit = defineEmits<Emits>()

const availableShiftTypes = [
  ShiftTypeDTO.FIRST_SHIFT,
  ShiftTypeDTO.BACKUP_SHIFT,
  ShiftTypeDTO.NO_SHIFT
]
</script>

<style scoped></style>
